import arrowSquareLeftBlue from "../assets/img/arrow-square-left-blue.svg";
import arrowSquareLeftPink from "../assets/img/arrow-square-left-pink.svg";
import arrowSquareLeftGreen from "../assets/img/arrow-square-left-green.svg";
import arrowSquareLeftPurple from "../assets/img/arrow-square-left-purple.svg";
import importImgBlue from "../assets/img/import-blue.svg";
import importImgPink from "../assets/img/import-pink.svg";
import importImgGreen from "../assets/img/import-green.svg";
import importImgPurple from "../assets/img/import-purple.svg";
import printImgtBlue from "../assets/img/printer-blue.svg";
import printImgPink from "../assets/img/printer-pink.svg";
import printImgGreen from "../assets/img/printer-green.svg";
import printImgPurple from "../assets/img/printer-purple.svg";
import editImgBlue from "../assets/img/edit-blue.svg";
import editImgPink from "../assets/img/edit-pink.svg";
import editImgGreen from "../assets/img/edit-green.svg";
import editImgPurple from "../assets/img/edit-purple.svg";

export const blue = {
  loaded: true,
  unit: "px",
  base: "",
  fontSize: {
    heading1: 40,
    heading2: 20,
    heading3: 18,
    heading4: 14,
    text1: 16,
    text2: 15,
    text3: 14,
    text4: 12,
  },
  color: {
    black: "#000000",
    navy: "#092C4C",
    primary: "#514EF3",
    palePrimary: "#C6C5FF",
    error: "red",
    green: "#2DC8A8",
    gray100: "#526477",
    gray70: "#7E92A2",
    gray71: "#5B7386",
    gray90: "#3D5064",
    gray50: "#D6E1E6",
    gray30: "#EAEEF4",
    gray10: "#F6FAFD",
    gray25: "#F5F5F5",
    gray200: "#D9D7E5",
    gray300: "#C9C8D8",
    gray400: "#B6B4C6",
    gray500: "#8F8CA0",
    gray600: "#68657D",
    gray800: "#E3E5FF",
    white: "#FFFFFF",
    checkedStatus: "#A6FFC9",
    success700: "#296004",
    success50: "#D7FFEF",
    error600: "#680000",
    error50: "#FFE8E7",
    error100: "#FFEBE6",
  },
  space(...args) {
    const result = (args.length ? [...args] : [1]).reduce(
      (str, curr) => `${str} ${curr}px`,
      ""
    );
    return result;
  },
  css: {
    borderRadius: 21,
    centered:
      "position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);",
    transition: "all 300ms ease-in-out;",
    boxShadow: "0px 4px 6px -2px rgba(0,0,0,0.5);",
  },
  img: {
    arrowSquareLeft: arrowSquareLeftBlue,
    importImg: importImgBlue,
    printImg: printImgtBlue,
    editImg: editImgBlue,
  },
};

export const pink = {
  ...blue,
  color: { ...blue.color, primary: "#FD4370", palePrimary: "#FFC0EA" },
  img: {
    arrowSquareLeft: arrowSquareLeftPink,
    importImg: importImgPink,
    printImg: printImgPink,
    editImg: editImgPink,
  },
};

export const green = {
  ...blue,
  color: { ...blue.color, primary: "#19B200", palePrimary: "#D7FF96" },
  img: {
    arrowSquareLeft: arrowSquareLeftGreen,
    importImg: importImgGreen,
    printImg: printImgGreen,
    editImg: editImgGreen,
  },
};

export const purple = {
  ...blue,
  color: { ...blue.color, primary: "#6700CD", palePrimary: "#DCC0FF" },
  arrowSquareLeft: arrowSquareLeftPurple,
  importImg: importImgPurple,
  printImg: printImgPurple,
  editImg: editImgPurple,
};
